import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ITask, ITaskBoardFilter, ITaskBoardQuery, ITaskFilter } from '../task.interface';
import { TaskHttpService } from '../task-http.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import * as _ from 'lodash';
import { TaskModalComponent } from '../task-modal/task-modal.component';
import { Router } from '@angular/router';
import { TaskStatusRelated, TaskStatuses } from '../task.constants';
import { TaskBoard, TaskBoardColumn } from './task-board.model';
import { TaskScheduleComponent } from '../task-schedule/task-schedule.component';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';
import { HelpVideoModalComponent } from '../../../../shared/components/help-video-modal/help-video-modal.component';

let self: any;

@Component({
  selector: 'app-task-board',
  templateUrl: './task-board.component.html',
  styleUrls: ['./task-board.component.css']
})
export class TaskBoardComponent implements OnInit {
  tasks: ITask[] = [];
  thereAreMore: boolean = false;
  loading: boolean = false;
  filter: ITaskBoardFilter = {
    filters: {
      scheduled: 'TODAY',
      completed: 'TODAY',
      invoiced: 'TODAY',
      cancelled: 'TODAY'
    },
    sort: '',
    skip: 0,
    limit: 30
  };
  filterAllData: any = {
    sort: '',
    skip: 0,
    limit: 4,
    filters: {}
  };
  filtered = false;
  filter_sort: string = 'createdAt';
  taskStatuses: any = TaskStatuses;
  taskStatusesKeys = Object.keys(TaskStatuses);
  taskStatusRelated: any = TaskStatusRelated;
  board!: TaskBoard | undefined;
  keepLoading: boolean = true;
  curr!: string;
  isDev!: boolean;
  isMobile: boolean = false;
  safeSrc: SafeResourceUrl;
  totalMoreMinTutorial = false;
  bulkInvoicing: boolean = false;

  constructor(
    public _TaskHttpService: TaskHttpService,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _UtilsService: UtilsService,
    private alertService: AlertService,
    private router: Router,
    private _AuthService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private sanitizer: DomSanitizer
  ) {
    self = this;
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/JT1Zf8dQCAk?si=X8J5MFkEm7ZMSbYE");
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    this.filter.company = this._AuthService.companyId();
    this.filterAllData.company = this.filter.company;
    this._TaskHttpService.getTasks(this.filterAllData).subscribe((tasks: any) => {
      this.totalMoreMinTutorial = tasks.length > 3;
    });
    this.getTasks(true);
    this.isMobile = this.isMobileWidth();
    const customBreakpoint = this.breakpointObserver.observe([
      `(max-width: 991px)`
    ]);

    customBreakpoint.subscribe((state: BreakpointState) => {
      this.isMobile = state.matches;
    });
  }

  resetBoard() {
    this.board = undefined;
    this.filter.skip = 0;
    this.tasks = [];
    this.thereAreMore = true;
  }

  async drawBoard(tasks?: ITask[]) {
    // console.log(tasks);
    if (!this.board) this.board = new TaskBoard('', []);
    if (!this.board.columns.length) {
      for (let status of this.taskStatusesKeys) {
        this.board.columns.push(new TaskBoardColumn(this.taskStatuses[status], status, []));
      }
      // this.board.columns = this.board.columns.filter(el => el.value != 'QUOTED');
    }
    // console.log (this.board.columns)
    for (let column of this.board.columns) {
      column.tasks = _.concat(column.tasks,
        (tasks as any)
          .filter((task: any) => task.status == column.value)
          .map((task: any) => {
            // if (column.value == 'CANCELLED') console.log(task);
            return {
              name: task.title,
              task: task,
              workers: (task.workers || []).map((el: any) => el.firstname + ' ' + el.lastname).join(', ')
            }
          })
      );

      /* REFACTOR */
      if (column.value == "INVOICED") {
        column.tasks = column.tasks.reverse()
      }
      /* REFACTOR */
    }
  }

  isMobileWidth(): boolean {
    if (typeof window !== 'undefined' && window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  drop(event: CdkDragDrop<any[]>) {
    let task = event.previousContainer.data[event.previousIndex];

    if (!(event.previousContainer === event.container)) {
      console.log('permitido mover hacia:', this.taskStatusRelated[task.task.status]);
      const allowed = this.taskStatusRelated[task.task.status].filter((el: any) => el == event.container.id).length;
      if (allowed) this.openTasksModal(task.task, false, true, event.container.id);
      else {
        const msg = this.taskStatusRelated[task.task.status].length
          ? "No Permitido. Este trabajo solo puede cambiar a: " + this.taskStatusRelated[task.task.status].map((st: any) => this.taskStatuses[st]).join(', ')
          : "Este trabajo no puede cambiar de estado"
        this.alertService.warn(msg);
      }

      /*
      // console.log(event.container.id);
      this.changeStatus(task.task, event.container.id, () => {
        this.alertService.info('Estado cambiado correctamente');
        (task.task as ITask).status = event.container.id;
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      });
      */
    }

    /*
    if (!(event.previousContainer === event.container)) {
      // console.log(event.container.id);
      this.changeStatus(task.task, event.container.id, () => {
        this.alertService.info('Estado cambiado correctamente');
        (task.task as ITask).status = event.container.id;
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      });
    }
    */
  }

  changeStatus(task: ITask, newStatus: string, cb?: any) {
    const status = _.get(this.taskStatuses, _.get(task, 'status', ''));
    const _newStatus = _.get(this.taskStatuses, newStatus, '');
    // console.log(newStatus);
    const modalOptions: IConfirmationDialogOptions = {
      title: "Mover Trabajo",
      message: `Esta seguro que desea mover este Trabajo de ${status} a ${_newStatus}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe(async (confirmation: any) => {
        if (confirmation) {
          if (newStatus == 'SCHEDULED') {
            await this.openTaskScheduleModal(task, newStatus)
            if (cb) cb();
          } else {
            this._TaskHttpService.changeStatus(task, newStatus).subscribe((result) => {
              if (cb) cb()
            });
          }
        }
      });
  }

  getTasks(reset: boolean = false) {
    if (reset) this.resetBoard();
    this.loading = true;
    this.thereAreMore = false;
    const filter: ITaskBoardQuery = this.getFilter();
    this._TaskHttpService.getBoardTasks(filter).subscribe((tasks: ITask[]) => {

      /* REFACTOR */
      for (const task of tasks) {
        try {
          task.duration = Math.round((new Date(task.scheduledEnd || '').getTime() - new Date(task.scheduledStart || '').getTime()) / (1000 * 60 * 60))
        } catch (e) { console.log(e) }
      }
      /* REFACTOR */

      this.tasks = _.concat(this.tasks, tasks);
      const filter: any = this.filter;
      this.thereAreMore = tasks.length >= filter.limit;
      this.loading = false;
      this.drawBoard(tasks);
      if (this.thereAreMore && this.keepLoading) this.loadMore();
    })
  }

  getFilter() {
    let query: ITaskBoardQuery = _.cloneDeep(this.filter as any);
    query.filters = {};

    const dayOffset = (24 * 60 * 60 * 1000);

    let scheduledStart: any = new Date();
    let scheduledEnd = undefined;
    const filter: any = this.filter;
    if (filter.filters.scheduled == 'TODAY') scheduledEnd = new Date(scheduledStart);
    if (filter.filters.scheduled == 'WEEK') scheduledEnd = new Date(scheduledStart.getTime() + (7 * dayOffset) - 1);
    if (filter.filters.scheduled == 'MONTH') scheduledEnd = new Date(scheduledStart.getTime() + (30 * dayOffset) - 1);
    if (filter.filters.scheduled == 'ALL') scheduledStart = undefined;
    if (scheduledStart && scheduledEnd) {
      query.filters.scheduledStart = this._UtilsService.date.localeStartOfDay(scheduledStart);
      query.filters.scheduledEnd = this._UtilsService.date.localeEndOfDay(scheduledEnd);
    }

    let completedStart = undefined;
    let completedEnd: any = new Date();
    if (filter.filters.completed == 'TODAY') completedStart = new Date(completedEnd);
    if (filter.filters.completed == 'WEEK') completedStart = new Date(completedEnd.getTime() - (7 * dayOffset) + 1);
    if (filter.filters.completed == 'MONTH') completedStart = new Date(completedEnd.getTime() - (30 * dayOffset) + 1);
    if (filter.filters.completed == 'ALL') completedEnd = undefined;
    if (!filter.filters.completed) completedStart = new Date(completedEnd.getTime() + (1 * dayOffset));
    if (completedStart && completedEnd) {
      query.filters.completedStart = this._UtilsService.date.localeStartOfDay(completedStart);
      query.filters.completedEnd = this._UtilsService.date.localeEndOfDay(completedEnd);
    }

    let invoicedStart = undefined;
    let invoicedEnd: any = new Date();
    if (filter.filters.invoiced == 'TODAY') invoicedStart = new Date(invoicedEnd);
    if (filter.filters.invoiced == 'WEEK') invoicedStart = new Date(invoicedEnd.getTime() - (7 * dayOffset) + 1);
    if (filter.filters.invoiced == 'MONTH') invoicedStart = new Date(invoicedEnd.getTime() - (30 * dayOffset) + 1);
    if (filter.filters.invoiced == 'ALL') invoicedEnd = undefined;
    if (!filter.filters.invoiced) invoicedStart = new Date(invoicedEnd.getTime() + (1 * dayOffset));
    if (invoicedStart && invoicedEnd) {
      query.filters.invoicedStart = this._UtilsService.date.localeStartOfDay(invoicedStart);
      query.filters.invoicedEnd = this._UtilsService.date.localeEndOfDay(invoicedEnd);
    }

    let cancelledStart = undefined;
    let cancelledEnd: any = new Date();
    if (filter.filters.cancelled == 'TODAY') cancelledStart = new Date(cancelledEnd);
    if (filter.filters.cancelled == 'WEEK') cancelledStart = new Date(cancelledEnd.getTime() - (7 * dayOffset) + 1);
    if (filter.filters.cancelled == 'MONTH') cancelledStart = new Date(cancelledEnd.getTime() - (30 * dayOffset) + 1);
    if (filter.filters.cancelled == 'ALL') cancelledEnd = undefined;
    if (!filter.filters.cancelled) cancelledStart = new Date(cancelledEnd.getTime() + (1 * dayOffset));
    if (cancelledStart && cancelledEnd) {
      query.filters.cancelledStart = this._UtilsService.date.localeStartOfDay(cancelledStart);
      query.filters.cancelledEnd = this._UtilsService.date.localeEndOfDay(cancelledEnd);
    }

    return query;
  }

  loadMore() {
    const filter: any = this.filter;
    filter.skip += filter.limit;
    this.getTasks();
  }

  ngOnDestroy() {
    // destruir suscripciones
    this.keepLoading = false;
  }

  openNewTaskModal(selected: string) {
    (selected === 'SCHEDULED') ? this.openTasksModal({ status: selected }, true, false) : this.openTasksModal({ status: selected }, undefined, false);
  }

  openTasksModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true, newStatus?: string,) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.readOnly = readOnly;
    self.dialogRef.componentInstance.scheduling = scheduling;
    self.dialogRef.componentInstance.newStatus = newStatus;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      this.getTasks(true);
      /*
      if (result) {
        // this.resetBoard();
        this.getTasks(true);
      } */
    });
  }

  async openDuplicateTaskModal(task: ITask, readOnly: boolean = false) {
    task = await lastValueFrom(this._TaskHttpService.getTask(task));

    const modalOptions: IConfirmationDialogOptions = {
      title: "Duplicar Trabajo",
      message: "Está seguro que desea crear un nuevo trabajo copiando el contenido seleccionado?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          let data = _.cloneDeep(task);
          data.status = 'SCHEDULED';

          delete data._id;
          delete data.createdAt;
          delete data.createdBy;
          delete data.scheduledStart;
          delete data.scheduledEnd;
          delete data.appointment;
          // console.log(data)

          let config = new MatDialogConfig();
          // config.disableClose = true;
          config.width = '1300px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          self.dialogRef = this._dialog.open(TaskModalComponent, config);
          self.dialogRef.componentInstance.task = data;
          // self.dialogRef.componentInstance.readOnly = readOnly;
          self.dialogRef.componentInstance.readOnly = false;
          self.dialogRef.componentInstance.scheduling = true;

          self.dialogRef.afterClosed().subscribe((result: any) => {
            self.dialogRef = null;
            if (result) {
              // this.resetBoard();
              this.getTasks(true);
            }
          });
        }
      });
  }

  openDeleteTaskConfirm(task: ITask, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Trabajo",
      message: "Esta seguro que desea eliminar '" + task.title + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.deleteTask(task, hardDelete).subscribe(() => {
            // this.resetBoard();
            this.getTasks(true);
          })
        }
      });
  }

  openRestoreTaskConfirm(task: ITask) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Trabajo",
      message: "Esta seguro que desea restaurar '" + task.title + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.restoreTask(task).subscribe(() => {
            // this.resetBoard();
            this.getTasks(true);
          })
        }
      });
  }

  openTasksList() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-list']);
  }

  openTasksByVisit() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks']);
  }

  openTasksComments() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-comments']);
  }

  openTaskScheduleModal(task: ITask, newStatus: string): Promise<void> {
    return new Promise((resolve, reject) => {
      let config = new MatDialogConfig();
      config.width = '600px';
      config.maxWidth = '90vw';
      config.viewContainerRef = this._viewContainerRef;
      self.dialogRef = this._dialog.open(TaskScheduleComponent, config);
      self.dialogRef.componentInstance.task = task;
      self.dialogRef.componentInstance.newStatus = newStatus;

      self.dialogRef.afterClosed().subscribe((result: any) => {
        self.dialogRef = null;
        resolve()
      });
    })
  }

  openWorkCategories() {
    this.openUnderConstructionDialog();
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "Ups!",
      message: "El enlace se encuentra en construccion",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  openHelpVideoModal() {
    let config = new MatDialogConfig();
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(HelpVideoModalComponent, config);
    self.dialogRef.componentInstance.helpLink = this.safeSrc;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }

}